import gql from 'graphql-tag';

import conversationFragment from './conversationFragment';
import dokkioTagFragment from './dokkioTagFragment';
import integrationItemFragment from './integrationItemFragment';

export const starredObjectsFragment = gql`
  fragment starredObjectsFragment on StarredObjects {
    dokkioClass
    conversationIDs
    conversations {
      ...conversationFragment
    }
    dokkioTagIDs
    dokkioTags {
      ...dokkioTagFragment
    }
    integrationItems {
      ...integrationItemFragment
    }
    integrationItemKinds
  }
  ${conversationFragment}
  ${dokkioTagFragment}
  ${integrationItemFragment}
`;
export default starredObjectsFragment;
